import { createPersistedQueryLink } from "apollo-link-persisted-queries";

const useGETForHashedQueries =
  process.env.FRONT_COMMERCE_WEB_USE_GET_FOR_PERSISTED_QUERIES === "true";
export default () =>
  createPersistedQueryLink({
    useGETForHashedQueries,
  });
